const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default function (el) {
  if (el === null) return false;

  const button = el.querySelector('.js-nav__button');
  const menu = el.querySelector('.js-nav__menu');
  const links = menu.querySelectorAll('.js-nav__link');
  const body = document.querySelectorAll('.main-body');

  if(button) {
    button.addEventListener('click', function (event) {
      const expanded = this.getAttribute('aria-expanded');
    
      if (expanded === 'false') {
        this.setAttribute('aria-expanded', 'true');
        button.classList.add('is-active', 'border-white');
        body.forEach((element) => {
          element.classList.add('opacity-50');
        });
    
        menu.classList.remove('-z-10', 'invisible', 'translate-x-full');
        menu.classList.add('translate-x-0');
    
        disableBodyScroll(menu);
    
        setTimeout(function () {
          links.forEach((element) => {
            element.classList.remove('opacity-0');
            element.classList.add('opacity-100');
          });
        }, 50);
      } else {
        this.setAttribute('aria-expanded', 'false');
    
        links.forEach((element) => {
          element.classList.remove('opacity-100');
          element.classList.add('opacity-0');
        });
    
        enableBodyScroll(menu);
    
        setTimeout(function () {
          menu.classList.remove('translate-x-0');
          menu.classList.add('translate-x-full', 'invisible', '-z-10');
    
          button.classList.remove('is-active', 'border-white');
          body.forEach((element) => {
            element.classList.remove('opacity-50');
          });
        }, 200);
      }
    });
  }

  const submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
  submenuToggles.forEach(button => {
    button.addEventListener('click', function(event) {
      event.stopPropagation();

      const submenu = this.nextElementSibling;
      const isSubmenuOpen = !submenu.classList.contains('hidden');

      const allSubmenus = document.querySelectorAll('.submenu');
      allSubmenus.forEach(submenu => submenu.classList.add('hidden'));

      const allArrows = document.querySelectorAll('.arrow');
      allArrows.forEach(arrow => {
        arrow.classList.add('arrow-bottom');
        arrow.classList.remove('arrow-top')
      });

      if (!isSubmenuOpen) {
        submenu.classList.remove('hidden');
        this.querySelector('.arrow').classList.add('arrow-top');
        this.querySelector('.arrow').classList.remove('arrow-bottom');
      }
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function() {
    const allSubmenus = document.querySelectorAll('.submenu');
    allSubmenus.forEach(submenu => submenu.classList.add('hidden'));

    const allArrows = document.querySelectorAll('.arrow');
    allArrows.forEach(arrow => {
      arrow.classList.add('arrow-bottom');
      arrow.classList.remove('arrow-top')
    });
  });

}
